/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsCreate } from "../../funcs/authServiceAccountsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateServiceAccountRequest$inboundSchema,
};

export const tool$authServiceAccountsCreate: ToolDefinition<typeof args> = {
  name: "auth-service-accounts-create",
  description: `Create a service account

Mint a non-human principal scoped to this org (org owner/admin only).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authServiceAccountsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
